import { nanoid } from 'nanoid';
import Color from 'color';

import { COLOR_RANGE } from '../../constants/const';
import { AdditionalInfoEnum, IPalettes } from '../../types';

import generateMainColor, { getRandomArbitrary } from './generateMainColor';

export const generatePalettes = (count: number, color: string | null, palettes?: IPalettes) => {
  const randomColor = generateMainColor(color);
  let prevColor = randomColor;

  if (color != null) {
    count--;
    prevColor = generateMainColor(null);
  }

  let newPalettes = [...Array(count)].map((_, index) => {
    const getRandomRange = getRandomArbitrary(COLOR_RANGE, 360 / count);
    const newColor = prevColor.rotate(getRandomRange);
    prevColor = newColor;

    if (palettes && palettes[index].isLocked) {
      return palettes[index];
    }
    return {
      color: newColor,
      shadesIndex: 0,
      isLocked: false,
      id: nanoid(),
      additionalInfo: AdditionalInfoEnum.NAME,
    };
  });

  if (color != null)
    newPalettes = [
      {
        color: randomColor,
        shadesIndex: 0,
        isLocked: true,
        id: nanoid(),
        additionalInfo: AdditionalInfoEnum.NAME,
      },
      ...newPalettes,
    ];
  return newPalettes;
};
export const generatePaletteFromUrl = (colors: Color<string>[]) => {
  return colors.map((newColor) => ({
    color: newColor.hsv(),
    shadesIndex: 0,
    isLocked: false,
    id: nanoid(),
    additionalInfo: AdditionalInfoEnum.NAME,
  }));
};
